var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',_vm._b({staticClass:"relative roundedmodal",attrs:{"name":_vm.name},on:{"before-open":_vm.handleEvents,"opened":_vm.handleEvents,"before-close":_vm.handleEvents,"closed":_vm.handleEvents}},'modal',Object.assign({}, _vm.defaultOptions,
    _vm.dimensions,
    _vm.options),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }